/* narin. — variant-driven gallery filtering by alt-text tagging.
   Each media's alt text may contain an option value (e.g. "Olive", "White").
   A media tagged with a colour shows only when that colour is selected;
   untagged media are shared and always shown. Multiple images per colour OK. */
(function () {
  function tokens(value) {
    return value
      .toLowerCase()
      .split(/[^a-z0-9]+/)
      .filter(function (w) { return w.length >= 3; });
  }

  function selectedValues(scope) {
    var vals = [];
    scope.querySelectorAll('select').forEach(function (s) {
      if (s.value) vals.push(s.value);
    });
    scope.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
      if (r.value) vals.push(r.value);
    });
    return vals.map(function (v) { return v.toLowerCase().trim(); }).filter(Boolean);
  }

  function setup(gallery) {
    var raw = gallery.getAttribute('data-narin-option-values') || '';
    var optionValues = raw.split('||').map(function (v) { return v.trim(); }).filter(Boolean);
    if (!optionValues.length) return; // nothing to filter (single-variant product)

    // precompute the word-set of each option value
    var optionWordSets = optionValues.map(function (v) { return { value: v, words: tokens(v) }; });

    var picker =
      document.querySelector('product-info') ||
      document.querySelector('.product__info-container') ||
      document;

    function altTags(alt) {
      // which option values this media is tagged with (by shared word)
      return optionWordSets
        .filter(function (o) {
          return o.words.some(function (w) { return alt.indexOf(w) !== -1; });
        })
        .map(function (o) { return o.value; });
    }

    function apply() {
      var selected = selectedValues(picker); // e.g. ["duzak white"]
      var selectedWords = [];
      selected.forEach(function (s) { selectedWords = selectedWords.concat(tokens(s)); });

      gallery.querySelectorAll('[data-narin-alt]').forEach(function (el) {
        var alt = (el.getAttribute('data-narin-alt') || '').toLowerCase();
        var tags = altTags(alt);
        var show;
        if (!tags.length) {
          show = true; // untagged = shared
        } else {
          // show if any of this media's tags matches a selected option (by word)
          show = tags.some(function (t) {
            return tokens(t).some(function (w) { return selectedWords.indexOf(w) !== -1; });
          });
        }
        el.classList.toggle('narin-variant-hidden', !show);
      });
    }

    apply();

    // re-filter when the shopper changes a variant option
    document.addEventListener('change', function (e) {
      if (e.target.closest('product-info, .product-form, variant-selects, variant-radios')) {
        setTimeout(apply, 60);
        setTimeout(apply, 500); // again after Dawn's async section update settles
      }
    });

    // Dawn re-renders gallery media on variant change → re-apply (childList only,
    // so our own class toggles don't retrigger the observer)
    var obs = new MutationObserver(function () { apply(); });
    obs.observe(gallery, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('media-gallery[data-narin-option-values]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
